export class NotContainsLowercaseError extends Error {
  constructor () {
    super('O campo deve ter ao menos uma letra minúscula')
    this.name = 'NotContainsLowercaseError'
  }
}
